export const routes = {
    "/:taskId/oldReferralReport/*": {
        title: "Referral Report"
    },
    "/:taskId/referralReport": {
        title: "Referral Report"
    },
    "/:taskId/oldAmendReferralReport/*": {
        title: "Referral Report"
    },
    "/:taskId/amendReferralReport": {
        title: "Referral Report"
    },
    "/:taskId/oldQAAmendReferralReport/*": {
        title: "Referral Report"
    },
    "/:taskId/qaAmendReferralReport": {
        title: "Referral Report"
    },
    "/:taskId/oldEditReferralReport/*": {
        title: "Referral Report"
    },
    "/:taskId/editReferralReport": {
        title: "Referral Report"
    }
};
